import * as actionTypes from './actionTypes';
import constants from "../../utils/constants";

const log = require("loglevel").getLogger("contactReducer");
log.setLevel("debug");

const initialState = JSON.stringify({
	awsContacts: [],
	awsContactsTotal: 0,
	msContacts: [],
	msContactsTotal: 0
});

function contactReducer(state = JSON.parse(initialState), action) {
	switch (action.type) {
		case constants.GLOBAL_ACTION_INIT_STATE: {
			log.debug("reset contact state");
			return initialState;
		}
		case actionTypes.CONTACT_LOADED: {
			const loadedContact = action.data;
			const { vendor } = action

			if(vendor === 'aws') {
				let contacts = state.awsContacts;
				const index = (contacts || []).findIndex(c => c.contact_id === loadedContact.contact_id);

				if(index > -1) {
					contacts[index] = loadedContact;
				}
				else {
					contacts.push(loadedContact);
				}

				return {
					...state,
					awsContacts: contacts
				};
			}
			else {
				let contacts = state.msContacts;
				const index = (contacts || []).findIndex(c => c.contact_id === loadedContact.contact_id);

				if(index > -1) {
					contacts[index] = loadedContact;
				}
				else {
					contacts.push(loadedContact);
				}

				return {
					...state,
					msContacts: contacts
				};
			}
		}
		case actionTypes.CONTACTS_LOADED: {
			if(action.vendor === 'aws') {
				return {
					...state,
					awsContacts: action.data,
					awsContactsTotal: action.total
				};
			}
			else {
				return {
					...state,
					msContacts: action.data,
					msContactsTotal: action.total
				};
			}
		}
		default:
			return state;
	}
}

export default contactReducer;
